"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var types_1 = require("../../sources/types");
var logos = __importStar(require("../../sources/lib/logos"));
var icon = logos.elasticsearch;
var elasticsearchDestination = {
    description: ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "Elasticsearch destination" })),
    syncFromSourcesStatus: "not_supported",
    id: "elasticsearch",
    type: "other",
    community: true,
    displayName: "Elasticsearch",
    parameters: [
        {
            id: "_super_type",
            constant: "npm",
        },
        {
            id: "_package",
            constant: "@tangible/jitsu-elasticsearch-destination@latest",
        },
        {
            id: "_formData.meta_package",
            displayName: "Community Package",
            type: types_1.descriptionType,
            defaultValue: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Implementation is based on ", (0, jsx_runtime_1.jsx)("b", { children: "npm-package:" }), " ", (0, jsx_runtime_1.jsx)("a", __assign({ target: "_blank", href: "https://www.npmjs.com/package/@tangible/jitsu-elasticsearch-destination" }, { children: "@tangible/jitsu-elasticsearch-destination" })), " ", "(version: latest)", (0, jsx_runtime_1.jsx)("br", {}), "Developed by", " ", (0, jsx_runtime_1.jsx)("a", __assign({ target: "_blank", href: "https://teamtangible.com" }, { children: "Tangible Inc" }))] })),
        },
        {
            id: "_formData.anonymous",
            displayName: "Send anonymous data",
            required: false,
            type: types_1.booleanType,
            documentation: ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "Send anonymous data to Elasticsearch if true or all data including user data if false." })),
        },
        {
            id: "_formData.elasticsearch_domain",
            displayName: "Elasticsearch server URL",
            required: true,
            type: types_1.stringType,
            documentation: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "Elasticsearch server domain including protocol (http(s)://<domain>)" }),
        },
        {
            id: "_formData.elasticsearch_port",
            displayName: "Elasticsearch server port",
            required: false,
            type: types_1.stringType,
        },
        {
            id: "_formData.elasticsearch_apikey",
            displayName: "Elasticsearch Api Key",
            required: true,
            type: types_1.passwordType,
        },
        {
            id: "_formData.elasticsearch_target",
            displayName: "Elasticsearch target",
            required: true,
            type: types_1.stringType,
            documentation: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["If the Elasticsearch security features are enabled, you must have the following index privileges for the target data stream, index, or index alias:", (0, jsx_runtime_1.jsx)("br", {}), "To add or overwrite a document using the PUT ", "/<target>/_doc/<_id>", " request format, you must have the create, index, or write index privilege.", (0, jsx_runtime_1.jsx)("br", {}), "To add a document using the POST ", "/<target>/_doc/", ", PUT ", "/<target>/_create/<_id>", ", or POST ", "/<target>/_create/<_id>", " request formats, you must have the create_doc, create, index, or write index privilege.", (0, jsx_runtime_1.jsx)("br", {}), "To automatically create a data stream or index with an index API request, you must have the auto_configure, create_index, or manage index privilege."] }),
        },
    ],
    ui: {
        icon: icon,
        connectCmd: null,
        title: function (cfg) { return ""; },
    },
};
exports.default = elasticsearchDestination;
